<template>
  <div class="item">
    <div class="field-narrow">{{ index + 1 }}</div>
    <div class="field-medium">{{ item.project }}</div>
    <div class="field-medium">{{ item.name }}</div>
    <div class="field-medium">{{ item.type_name }}</div>
    <div class="field-medium" v-html="convertMessage(item.type, item.message)" />
    <div class="field-medium">{{ convertGMT0toGMT8(item.createtime) }}</div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';
import { convertGMT0toGMT8 } from '../utils/stringValid';

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const apiBaseUrl = inject('apiBaseUrl');
    const url = 'data';
    return { t, apiBaseUrl, url };
  },
  methods: {
    convertGMT0toGMT8,
    convertMessage(type, message) {
      switch (type) {
        case 1: {
          const state = parseInt(message, 10);
          if (state === 2) {
            return '已連線';
          }
          return '未連線';
        }
        case 2:
        {
          const value = parseInt(message, 10);
          if (value < 0) {
            return `充電中${message}%`;
          }
          return `${message}%`;
        }
        case 5:
          {
            const parts = message.split(':');
            if (parts.length === 3) {
              return `${this.t('latitude')}: ${parts[0]}<br>${this.t('longitude')}:${
                parts[1]
              }<br>${this.t('speed')}:${parts[2]}`;
            }
          }
          break;
        case 6:
          {
            const parts = message.split(':');
            if (parts.length === 2) {
              return `觸發: ${parts[0]}<br>流水號:${parts[1]}`;
            }
          }
          break;
        default:
          break;
      }
      return message;
    },
  },
};
</script>

<style>
.item {
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  padding: 10px;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}
.field-medium-path {
  flex: 2;
  text-align: left;
}
</style>
